import { Bank } from '@ap/interface-bspc-core';

export type Token = DigicodeToken | DigipasToken | DeviceBoundToken;

export interface BaseToken {
    id?: string;
    registered_at: string;
    type_id: TokenTypeId;
    status: TokenStatus;
    last_authenticated_at?: string;
    last_authentication_attempt_at?: string;
    is_temporarily_blocked?: boolean;
    user?: Party;
}

export interface DigipasToken extends BaseToken {
    serial_number: string;
    ascription?: string;
}

export interface DigicodeToken extends BaseToken {
    username: string;
    is_username_change_required: boolean;
    is_password_change_required: boolean;
}

export interface DeviceBoundToken extends BaseToken {
    device_id: string;
}

export interface Device {
    id?: string;
    platform: Platform;
    application: Application;
    tokens?: DeviceBoundToken[];
    device_token_registered_at: string;
    status?: DeviceStatus;
    user: Party;
}

export enum DeviceStatus {
    ACTIVE = 'active',
    BLOCKED = 'blocked',
    EXPIRED = 'expired'
}

export interface Platform {
    description: string;
    manufacturer?: string;
    product?: string;
    name?: string;
    os_family?: string;
}

export interface Application {
    id: string;
    description: string;
    type: ApplicationType;
    banks: Bank[];
}

export enum TokenStatus {
    ACTIVE = 'active',
    BLOCKED = 'blocked',
    EXPIRED = 'expired',
    REMOVED = 'removed'
}

export interface PageOfDevices {
    next_cursor: string;
    devices: Device[];
}

export interface PageOfTokens {
    next_cursor: string;
    tokens: Token[];
}

export enum ApplicationType {
    ANDROID = 'android',
    IOS = 'ios',
    BROWSER = 'browser'
}

export interface DevicePatch {
    status?: DeviceStatus;
    user_fullname?: string;
    user?: Party;
}

export interface Party {
    id?: string;
    type?: PartyType;
    eb_contract_id?: string;
}

export enum PartyType {
    CUSTOMER = 'customer',
    EMPLOYEE = 'employee',
    PROSPECT = 'prospect',
    ANONYMOUS = 'anonymous',
    INTERMEDIARY = 'intermediary'
}

export enum TokenTypeId {
    DIGIPAS = 'digipas',
    DIGICODE = 'digicode',
    MOBILE_DEVICE_LOW = 'mobile_device_low',
    MOBILE_DEVICE = 'mobile_device',
    MOBILE_FINGERPRINT_LOW = 'mobile_fingerprint_low',
    MOBILE_FINGERPRINT = 'mobile_fingerprint',
    MOBILE_FACE_LOW = 'mobile_face_low',
    MOBILE_FACE = 'mobile_face',
    MOBILE_PIN_LOW = 'mobile_pin_low',
    MOBILE_PIN = 'mobile_pin',
    BROWSER_DEVICE = 'browser_device',
    BROWSER_PINCODE = 'browser_pin'
}

export interface UserRequest {
    user_id?: string;
    user_type?: string;
    user_eb_contract_id?: string;
    limitParam?: number;
    cursorParam?: string;
}

export interface TokenPatch {
    type_id: TokenTypeId;
    status?: TokenStatus;
    block_reason?: TokenBlockReason;
}

export enum TokenBlockReason {
    BLOCKED_BY_CUSTOMER_SERVICE = 'blocked_by_customer_service',
    TOO_MANY_CONSECUTIVE_LOGIN_FAILURES = 'too_many_consecutive_login_failures'
}

export interface DigicodeTokenPatch extends TokenPatch {
    username?: string;
    password?: string;
}
